import { useDefaultBracketPreferences } from './BracketPreferences/useDefaultBracketPreferences'
import { useDefaultMolarTubes } from './MolarTubes/useDefaultMolarTubes'

export const useDefaultPrescriptionValues = () => {
  useDefaultBracketPreferences()
  useDefaultMolarTubes()
}
